<app-black-container [showRegistrationFooter]="true">
  <div class="white-space-container">
    @if (isUrbanSitterRedirect) {
    <div id="urban-sitter-banner">
      <div class="horizontal-banner-flex">
        <img
          src="assets/img/Cariloop-Logo-Black.svg"
          [alt]="'GENERAL.CARILOOP_LOGO_ALT' | translate"
        />
        <mat-icon aria-hidden="true" fontIcon="add"></mat-icon>
        <img
          src="assets/img/urban-sitter-logo.png"
          [alt]="'GENERAL.URBAN_SITTER_LOGO_ALT' | translate"
        />
      </div>
      <p>{{'LOGIN.URBAN_SITTER_BANNER' | translate}}</p>
    </div>
    } @if (screen==='login') {
    <div class="form-container">
      <div class="title-container full-width">
        @if (screen==='login') {
        <h1 class="title">{{ 'LOGIN.TITLE' | translate }}</h1>
        }
      </div>
      @if (loginMessage && screen==='login') {
      <p class="header-md-medium header">
        {{loginMessage | translate }}
        <br />
        &nbsp;
      </p>
      }
      <div role="alert">
        <app-md-error-handler [error]="error"></app-md-error-handler>
      </div>
      @if (screen==='login') {
      <form (ngSubmit)="onSubmit(form)" #form="ngForm" class="login-form">
        <div class="inputs-container">
          <div class="input-container">
            <c-input-text
              #emailRef="ngModel"
              name="email"
              id="email"
              type="text"
              autocomplete="email"
              [(ngModel)]="model.email"
              (change)="lowercaseEmail(); validateEmail(form)"
              (animationstart)="animationEvent($event, 'email')"
              [label]="'LOGIN.EMAIL_ADDRESS' | translate "
              inputID="email-input"
              [required]="true"
            >
            </c-input-text>
            <div role="alert">
              @if (emailRef.touched && !emailRef.valid) {
              <span class="login__input-error">
                @if (emailRef?.errors?.pattern) {
                <p>{{ 'LOGIN.EMAIL_PATTERN_ERROR' | translate }}</p>
                } @if (emailRef?.errors?.required) {
                <p>{{ 'LOGIN.EMAIL_REQUIRED_ERROR' | translate }}</p>
                }
              </span>
              }
            </div>
          </div>
          <div class="input-container">
            <c-input-text
              [label]="'LOGIN.PASSWORD' | translate"
              #passRef="ngModel"
              [(ngModel)]="model.password"
              name="password"
              autocomplete="current-password"
              inputID="password-input"
              [required]="true"
              passwordVisibility
              showText="{{'LOGIN.PASSWORD_VISIBILITY_OFF' | translate}}"
              hideText="{{'LOGIN.PASSWORD_VISIBILITY_ON' | translate}}"
            >
              <div error-container role="alert">
                @if (passRef.touched && passRef.errors?.required) {
                <span class="login__input-error">
                  <p>{{ 'LOGIN.PASSWORD_ERROR' | translate }}</p>
                </span>
                }
              </div>
            </c-input-text>
          </div>
        </div>
        <div class="forgot-buttons-container">
          <a
            routerLink="/forgot-password"
            class="mat-link mat-caption forgot-password"
          >
            {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
          </a>
        </div>
        <div class="forgot-password-container full-width">
          <div class="buttons-flex">
            @if (!isLoading) {
            <c-button
              type="submit"
              [text]="'LOGIN.LOG_IN' | translate"
              class="full-button"
              buttonType="neutral"
              buttonStyle="fill"
              size="large"
            />
            } @if (isLoading) {
            <mat-spinner class="loading-spinner" [diameter]="40"></mat-spinner>
            } @if (!loginWithUrl && oneLoginUrl && !isUrbanSitterRedirect) {
            <p aria-hidden="true" class="mat-caption or-container full-width">
              {{ 'LOGIN.OR' | translate }}
            </p>
            <a
              [href]="oneLoginUrl"
              tabindex="0"
              [attr.aria-label]="'LOGIN.ONELOGIN_ARIA' | translate"
              class="full-width login-with-button"
            >
              {{ 'LOGIN.ONELOGIN' | translate }}
            </a>
            } @if (!loginWithUrl && alightUrl && !isUrbanSitterRedirect) {
            <p aria-hidden="true" class="mat-caption or-container full-width">
              {{ 'LOGIN.OR' | translate }}
            </p>
            <a
              [href]="alightUrl"
              tabindex="0"
              class="full-width login-with-button"
            >
              {{ 'LOGIN.ALIGHT_LOGIN' | translate }}
            </a>
            } @if (loginWithUrl) {
            <p aria-hidden="true" class="mat-caption or-container full-width">
              {{ 'LOGIN.OR' | translate }}
            </p>
            <a
              [href]="loginWithUrl"
              tabindex="0"
              class="full-width login-with-button"
            >
              {{ 'LOGIN.LOG_IN_WITH' | translate }} {{loginWithName}}
            </a>
            }
          </div>
          @if (!showSignInCodeField) {
          <div class="login-code-container full-width">
            <button
              class="mat-link login-code-text"
              id="login-code-button"
              (click)="openSignInCodeField()"
              tabindex="0"
            >
              {{ 'LOGIN.LOGIN_CODE' | translate }}
            </button>
          </div>
          } @if (showSignInCodeField) {
          <div class="sign-in-container">
            <form
              (ngSubmit)="loginWithCode(loginCodeForm)"
              #loginCodeForm="ngForm"
              id="loginCodeForm"
            >
              <div class="input-container">
                <c-input-text
                  required
                  name="loginCode"
                  #loginCodeModel="ngModel"
                  type="text"
                  [(ngModel)]="loginCode"
                  [label]="'LOGIN.CODE' | translate"
                  [ariaLabel]="'LOGIN.LOGIN_CODE_ARIA' | translate"
                  inputID="login-code-input"
                >
                </c-input-text>
                <div role="alert">
                  @if (loginCodeModel?.touched && !loginCodeModel.valid) {
                  <span class="login__input-error">
                    @if (loginCode && !loginCode.valid) {
                    <p>{{ 'LOGIN.LOGIN_CODE_ERROR_EXPIRED' | translate }}</p>
                    } @if (loginCodeModel.invalid) {
                    <p>{{ 'LOGIN.LOGIN_CODE_ERROR_INVALID' | translate }}</p>
                    }
                  </span>
                  }
                </div>
              </div>
              <c-button
                type="submit"
                [text]="'LOGIN.LOG_IN_WITH_CODE' | translate"
                class="full-button"
                buttonType="neutral"
                buttonStyle="fill"
                size="large"
                [buttonDisabled]="!loginCodeForm.form.valid"
              ></c-button>
            </form>
          </div>
          }
        </div>
      </form>
      }
      <div class="login__sign-up-container full-width">
        @if (showRegister && screen !== 'mfa') {
        <div>
          <p>{{ 'LOGIN.SIGN_UP_TEXT' | translate }}</p>
          <a
            routerLink="/register"
            class="mat-link"
            tabindex="0"
            id="sign-up-link"
          >
            {{ 'LOGIN.SIGN_UP' | translate }}
          </a>
        </div>
        }
      </div>
    </div>
    } @if (screen==='mfa' || screen==='mfaError') {
    <app-mfa-login
      [loginCredentials]="{email: model.email,password:model.password}"
      [mfaToken]="mfaToken"
      [mfaType]="mfaType()"
      (backToLogin)="screen='login'"
      (mfaSuccess)="handleLoginResponse($event)"
    ></app-mfa-login>
    } @if (screen==='member-assist-verify') {
    <div class="form-container">
      <div class="title-container full-width">
        <h1 class="title">{{ 'MEMBER_ASSIST.VERIFY.TITLE' | translate }}</h1>
      </div>
      <p class="header-md-medium header">
        {{ 'MEMBER_ASSIST.VERIFY.DESCRIPTION' | translate }}
      </p>
      <div role="alert">
        @if (memberAssistVerifyError) {
        <c-banner
          class="error-banner"
          [style]="'error'"
          [inline]="false"
          [message]="memberAssistVerifyError | translate"
          [showCloseButton]="false"
          [iconPositionX]="'center'"
        ></c-banner>
        }
      </div>
      <form
        (ngSubmit)="onMemberAssistVerify()"
        #memberAssistVerifyForm="ngForm"
        class="login-form"
        autocomplete="off"
      >
        <div class="inputs-container">
          <div class="input-container">
            <c-input-text
              name="memberAssistCode"
              type="text"
              [label]="'MEMBER_ASSIST.VERIFY.CODE_LABEL' | translate"
              [(ngModel)]="memberAssistVerifyCode"
              #memberAssistCodeModel="ngModel"
              inputID="member-assist-code-input"
              [required]="true"
              [attr.aria-label]="'MEMBER_ASSIST.VERIFY.CODE_LABEL' | translate"
              placeholder="{{ 'MEMBER_ASSIST.VERIFY.CODE_PLACEHOLDER' | translate }}"
            >
              <div error-container role="alert">
                @if (memberAssistCodeModel.touched &&
                memberAssistCodeModel.errors?.required) {
                <span class="login__input-error">
                  <p>{{ 'MEMBER_ASSIST.VERIFY.CODE_REQUIRED' | translate }}</p>
                </span>
                }
              </div>
            </c-input-text>
          </div>
        </div>
        <div class="forgot-buttons-container"></div>
        <div class="forgot-password-container full-width">
          <div class="buttons-flex">
            @if (!isLoading) {
            <c-button
              type="submit"
              [text]="'MEMBER_ASSIST.VERIFY.SUBMIT' | translate"
              class="full-button"
              buttonType="neutral"
              buttonStyle="fill"
              size="large"
              [buttonDisabled]="!memberAssistVerifyForm.form.valid"
            />
            } @if (isLoading) {
            <mat-spinner class="loading-spinner" [diameter]="40"></mat-spinner>
            }
          </div>
        </div>
      </form>
    </div>
    } @if (showMobileAdoptionCTA && screen !== 'mfa' && screen !==
    'member-assist-verify') {
    <app-cta-mobile class="cta-mobile"></app-cta-mobile>
    }
  </div>
  <div footer class="login__footer">
    <a
      class="footer__link"
      href="https://www.cariloop.com/terms-of-service/"
      target="_blank"
    >
      {{ "GENERAL.FOOTER.TERMS" | translate }}
    </a>
    <a
      class="footer__link"
      href="https://www.cariloop.com/privacy-policy/"
      target="_blank"
    >
      {{ "GENERAL.FOOTER.PRIVACY" | translate }}
    </a>
  </div>
</app-black-container>
<div class="analytics t-error" (dblclick)="throwError()"></div>

@if (showMobileWebCTA) {
<app-mobile-app-cta
  [device]="device"
  [isMobileDevice]="isMobileDevice"
  (shouldShowCTA)="changeMobileCTAState($event)"
  [@fadeInOut]="showMobileWebCTA"
></app-mobile-app-cta>
}
